export class LotCollectionViewModel {
    public readonly lotIds: number[];
    
    constructor(lotIds: number[]) {
        this.lotIds = lotIds;
    }
}